module.exports = __webpack_public_path__ + "static/media/29BDOS10.33ba88ba.jpg";